import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import creator from 'utils/action-creator';
import axios from 'utils/axios';

import { actions as profileActions } from 'sagas/app/workers/workersProfileSaga';

/**
 * Constants
 */
const POST_REQUEST = '@app/workers/workersprofile/gcc/POST_REQUEST';
const POST_FAILURE = '@app/workers/workersprofile/gcc/POST_FAILURE';

const TRIGGER_MODAL = '@app/workers/workersprofile/gcc/TRIGGER_MODAL';
const COLAPSE_MODAL = '@app/workers/workersprofile/gcc/COLAPSE_MODAL';

/**
 * Initial state
 */
const initState = {
    modal: false,
    modalLoading: false,
    modalError: ''
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */

// Reducer
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case POST_REQUEST:
                draft.modalLoading = true;
                draft.modalError = '';
                break;
            case POST_FAILURE:
                draft.modalLoading = false;
                draft.modalError = payload;
                break;

            case TRIGGER_MODAL:
                draft.modal = true;
                break;

            case COLAPSE_MODAL:
                draft.modal = false;
                draft.modalLoading = false;
                draft.modalError = '';
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Redux actions
 */
export const actions = {
    post_request: (data) => creator(POST_REQUEST, data),
    post_failure: (data) => creator(POST_FAILURE, data),

    trigger_modal: () => creator(TRIGGER_MODAL),
    colapse_modal: () => creator(COLAPSE_MODAL)
};

/**
 * Saga functions
 */
export const sagas = {
    *post_request({ payload }) {
        try {
            const { worker_id, user_id } = payload;

            const settings = {
                headers: { 'content-type': 'multipart/form-data' }
            };
            const data = new FormData();

            data.append('file', payload.file, payload.file.name);
            data.append('issued_at', payload.issued_at);
            data.append('category_id', payload.category_id);
            data.append('pcc_reference', payload.pcc_reference);

            yield axios.post(`/workers/gcc/${user_id}`, data, settings);

            yield put(actions.colapse_modal());
            yield put(profileActions.request(worker_id));
        } catch (e) {
            yield put(actions.post_failure('Submit failed, please contact support!'));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(POST_REQUEST, sagas.post_request);
};
